import { getLabels, deleteLabel } from './api.service';
import { actions } from './reducer';

const {
  getLabelsRequest,
  getLabelsSuccess,
  getLabelsFailure,
  deleteLabelRequest,
  deleteLabelSuccess,
  deleteLabelFailure,
} = actions;

export const fetchLabels = (query) => async (dispatch) => {
  try {
    dispatch(getLabelsRequest());
    const { data } = await getLabels(query);
    dispatch(getLabelsSuccess({ labels: data.data, meta: { ...query, ...data.meta } }));
  } catch (error) {
    dispatch(getLabelsFailure({ error }));
  }
};

export const deleteLabelById = (id) => async (dispatch) => {
  try {
    dispatch(deleteLabelRequest());
    const { data } = await deleteLabel(id);
    dispatch(deleteLabelSuccess({ deletedId: data.data.id, success: 'Label has been successfully deleted' }));
  } catch (error) {
    dispatch(deleteLabelFailure({ error }));
  }
};
